// ------------------------ utility ------------------------ //

setCookie = function (name, value, expireSeconds = 86400) {
    let expires = ''

    if (expireSeconds) {
        let date = new Date()

        date.setTime(date.getTime() + expireSeconds * 1000)

        expires = '; expires=' + date.toUTCString()
    }

    document.cookie = name + '=' + (value || '') + expires + ';domain=.' + document.location.host + ';path=/'
}

readCookie = function(name) {
    return document.cookie
        .split('; ')
        .find((row) => row.startsWith(name + '='))
        ?.split('=')[1]
}

loadScript = function (url, callback) {
    const scriptJS = document.createElement('script')
    scriptJS.type = 'text/javascript';
    scriptJS.src = url;
    scriptJS.addEventListener('load', callback)
    document.head.appendChild(scriptJS)
}

getUserLanguage = function() {
    let userLang = navigator.language;
        userLang = userLang.slice(0, 2)

    return userLang
}

setUserLanguage = function(inputId) {
    let inputElement = document.querySelector('#' + inputId)

    if (!inputElement.value) {
        inputElement.value = getUserLanguage()
    }
}

stringToSlug = function (str) {
    return str
        .toLowerCase() // convert string to lowercase
        .replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
        .replace(/^\s+|\s+$/g, '') // trim leading/trailing white space
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, '-') // remove consecutive hyphens
}

smoothScrollingTo = function (targetElement, offset = 0) {
    if (targetElement) {
        const element = document.querySelector(targetElement)

        if (element) {
            // Calculate the top offset of the element
            const elementTop = element.getBoundingClientRect().top + window.scrollY

            // Scroll to the calculated position with the offset
            window.scrollTo({
                top: elementTop - offset,
                behavior: 'smooth' // Smooth scrolling
            })
        }
    }
}

// ------------------------ common ------------------------ //

setLicenseNum = function(string) {
    document.querySelector('#license-num').textContent = string
}

processCTA = function (button) {
    const form = button.parentElement

    const input = form.querySelector('input[name="postal_code"]')

    if (input.value.length !== 5 || input.value === '00000') {
        //mark as invalid
        input.classList.add('is-invalid')
        input.classList.remove('is-valid')
    } else {
        //mark as valid
        input.classList.remove('is-invalid')
        input.classList.add('is-valid')

        //mark as loading
        button.innerHTML = '<span class="spinner-border" role="status" aria-hidden="true"></span> Please wait...'

        //submit
        form.submit()
    }
}

processCTAButton = function (button) {
    const form = button.parentElement

    form.submit()
}

setupFAQ = function () {
    document.querySelectorAll('.accordion-question').forEach(el => {
        el.addEventListener('click', function () {
            this.classList.toggle('collapsed')

            let dataTarget = this.getAttribute('data-target')

            if (this.classList.contains('collapsed')) {
                document.querySelector('#' + dataTarget).classList.remove('show')
            } else {
                document.querySelector('#' + dataTarget).classList.add('show')
            }
        })
    })
}

setupFAQNew = function () {
    document.querySelectorAll('.faq-section .faq-item .faq-question').forEach(el => {
        el.addEventListener('click', function () {
            this.parentElement.classList.toggle('faq-item-open')
        })
    })
}

setupCTA = function () {
    document.querySelectorAll('.form').forEach((form) => {
        form.addEventListener('keypress', function (e) {
            if (e.keyCode === 13) {
                e.preventDefault()

                const button = form.querySelector('button')
                processCTA(button)
            }
        })
    })
}

setupToggleDisclosureInformation = function() {
    const toggleDisclosureInformationButton = document.querySelector('#toggle-disclosure-information')
    const toggleDisclosureInformationContent = document.querySelector('#toggle-disclosure-information-content')

    toggleDisclosureInformationButton.addEventListener('click', () => {
        toggleDisclosureInformationContent.classList.toggle('hidden')
    })
}

getEverflowParameter = function (key) {
    return EF.urlParameter(key) || ''
}

setTransactionId = function (transaction_id) {
    document.querySelectorAll('input[name="transaction_id"]').forEach((input) => {
        input.value = transaction_id
    })
}

setupEverflow = function() {
    const oid = getEverflowParameter('oid')
    let transaction_id = EF.getTransactionId(oid)

    if (transaction_id) {
        setTransactionId(transaction_id)
    } else {
        EF.click({
            offer_id: oid,
            affiliate_id: getEverflowParameter('affid'),
            sub1: getEverflowParameter('sub1'),
            sub2: getEverflowParameter('sub2'),
            sub3: getEverflowParameter('sub3'),
            sub4: getEverflowParameter('sub4'),
            sub5: getEverflowParameter('sub5'),
            uid: getEverflowParameter('uid'),
            source_id: getEverflowParameter('source_id'),
            transaction_id: getEverflowParameter('_ef_transaction_id'),
            parameters: {
                ttclid: getEverflowParameter('ttclid'),
                gclid: getEverflowParameter('gclid'),
            },
        }).then(function (transaction_id) {
            setTransactionId(transaction_id)
        })
    }
}

setupArticle = function() {
    const stickyMobileContent = document.querySelector('#sticky-mobile-content')
    const stickyDesktopUl = document.querySelector('#sticky-desktop-ul')

    // Create table contents links based on article content <h2>
    document.querySelectorAll('.article-content h2').forEach((contentElement, contentNumber) => {
        const liText = contentElement.textContent
        const liAnchor = stringToSlug(liText)
        const liHtml =
            '<a href="#' + liAnchor + '" title="' + liText + '">' +
                liText +
            '</a>'

        // Mark headline with id attribute
        contentElement.id = liAnchor

        let liDesktopElement = document.createElement('li')
            liDesktopElement.id = 'stc-' +  (contentNumber + 1)
            liDesktopElement.innerHTML = liHtml

        stickyDesktopUl.appendChild(liDesktopElement)

        let liMobileElement = document.createElement('li')
            liMobileElement.innerHTML = liHtml

        stickyMobileContent.querySelector('#sticky-mobile-ul').appendChild(liMobileElement)
    })

    // Bind table contents links (note: there is some sort of bug / issue on first click on a anchor link without this)
    document.querySelectorAll('.sticky-ul a').forEach((linkElement) => {
        linkElement.addEventListener('click', function(e) {
            e.preventDefault()

            smoothScrollingTo(this.getAttribute('href'), 48)
        })
    })

    // Bind functionality for mobile table contents
    stickyMobileContent.querySelector('#sticky-mobile-container').addEventListener('click', function() {
        stickyMobileContent.classList.toggle('collapsed')
    })

    stickyMobileContent.querySelectorAll('#sticky-mobile-ul a').forEach((element) => {
        element.addEventListener('click', function() {
            stickyMobileContent.classList.remove('collapsed')
        })
    })

    function debounce(func, delay) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
        };
    }

    const is_viewport = window.matchMedia('(max-width: 1023px)').matches

    window.onscroll = debounce(function () {
        let y = window.scrollY
        let selectedContentNumber

        document.querySelectorAll('.article-content h2').forEach((contentElement, contentNumber) => {
            contentNumber = contentNumber + 1

            document.querySelector('#stc-' + contentNumber).classList.remove('is-selected')

            if (y > contentElement.offsetTop - 150) {
                selectedContentNumber = contentNumber
            }
        })

        if (selectedContentNumber) {
            document.querySelector('#stc-' + selectedContentNumber).classList.add('is-selected')
        }

        if (is_viewport === true) {
            if(y > stickyMobileContent.offsetTop) {
                stickyMobileContent.style.position = 'fixed'
            } else {
                stickyMobileContent.style.position = 'static'
            }
        }
    }, 100)

    smoothScrollingTo(window.location.hash, 48)
}
